import _ from 'lodash';
import { Component, OnInit, forwardRef, DestroyRef, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-recurring-donation',
  templateUrl: './recurring-donation.component.html',
  styleUrls: ['./recurring-donation.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RecurringDonationComponent),
    multi: true,
  }],
})
export class RecurringDonationComponent implements OnInit, ControlValueAccessor {
  destroyRef = inject(DestroyRef)
  public form: UntypedFormGroup = null;

  constructor(
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      'oneTime': new UntypedFormControl(false, []),
      'weekly': new UntypedFormControl(false, []),
      'monthly': new UntypedFormControl(false, []),
      'quarterly': new UntypedFormControl(false, []),
      'semiAnnual': new UntypedFormControl(false, []),
      'annual': new UntypedFormControl(false, [])
    });

    this.form.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((options) => {
      const optionsMap = _.map(options, (value, id) => {
        return { id, value };
      });
      const optionsList = _.filter(optionsMap, option => option.value);
      const value = _.map(optionsList, ({ id }) => {
        switch(id) {
          case 'oneTime':
            return 0;
          case 'weekly':
            return 1;
          case 'monthly':
            return 2;
          case 'quarterly':
            return 3;
          case 'semiAnnual':
            return 4;
          case 'annual':
            return 5;
        }
      });

      this.onChangeCallback(value);
    });
  }

  private onChangeCallback = (value: any) => {};
  private onTouchedCallback = () => {};

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouchedCallback = fn;
  }


  writeValue(list: number[]) {
    const { form } = this;
    const values = [false, false, false, false, false, false];
    const keys = ['oneTime', 'weekly', 'monthly', 'quarterly', 'semiAnnual', 'annual'];
    _.forEach(list, value => { values[value] = true })
    _.forEach(keys, (key, index) => { form.get(key).setValue(values[index], { emitEvent: false }) })
    form.updateValueAndValidity({ emitEvent: false });
  }

}
